import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { manualReconnect } from '../../actions/main_course';
import CountDown from '../../components/others/countdown';
import Translate from '../../hocs/translate';
import config from '../../config.json';
import './reconnect.scss';

class Reconnect extends Component {
  renderReconnectContent(reconnectState) {
    if (reconnectState === 'offline') {
      // no retry is scheduled while the device has no network, so this is a label: a button here
      // would look like it does something and be ignored
      return (
        <div className="reconnect-labels">
          <p className="reconnect-button">{this.props.strings['No connection']}</p>
        </div>
      );
    }

    if (reconnectState === 'waiting') {
      // the wait grows with each failed attempt (LMSNEXT-1325), and CountDown only reads its
      // starting value once, so the key remounts it whenever the wait changes
      const countDownInSeconds =
        this.props.reconnect.retryInSeconds || config.automaticReconnectTimeout / 1000;
      return (
        <div className="reconnect-labels">
          <button className="reconnect-button" onClick={this.props.manualReconnect}>
            {this.props.strings['Trying to reconnect in']}
          </button>
          <CountDown
            key={countDownInSeconds}
            resetOnFinish
            countDownInSeconds={countDownInSeconds}
          />
        </div>
      );
    }

    return (
      <div className="reconnect-labels">
        <button className="reconnect-button" onClick={this.props.manualReconnect}>
          {this.props.strings['Reconnecting...']}
        </button>
      </div>
    );
  }

  render() {
    if (this.props.reconnect.active) {
      return (
        <div className="reconnect-wrapper">
          {this.renderReconnectContent(this.props.reconnect.state)}
        </div>
      );
    }

    return null;
  }
}

function mapStateToProps(state) {
  return { reconnect: state.mainCourse.reconnect };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ manualReconnect }, dispatch);
}

export default Translate('Reconnect')(connect(mapStateToProps, mapDispatchToProps)(Reconnect));

Reconnect.defaultProps = {
  strings: {
    'Trying to reconnect in': 'Trying to reconnect in',
    'Reconnecting...': 'Reconnecting...',
    'No connection': 'No connection'
  }
};
